import React from 'react';
import { FileText, FileSpreadsheet, File, Download, Trash2, Loader } from 'lucide-react';
import type { UploadedFile, UploadProgress } from '../../hooks/useFileUpload';
interface FileListProps {
  files: UploadedFile[];
  uploadProgress: Record<string, UploadProgress>;
  onDelete: (file: UploadedFile) => void;
}
function getFileIcon(fileType: string) {
  if (fileType.includes('pdf')) {
    return <FileText className="w-5 h-5 text-red-500" data-id="element-2123" />;
  } else if (fileType.includes('sheet') || fileType.includes('excel')) {
    return <FileSpreadsheet className="w-5 h-5 text-green-500" data-id="element-2124" />;
  } else if (fileType.includes('word') || fileType.includes('document')) {
    return <FileText className="w-5 h-5 text-blue-500" data-id="element-2125" />;
  }
  return <File className="w-5 h-5 text-gray-500" data-id="element-2126" />;
}
function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}
export function FileList({
  files,
  uploadProgress,
  onDelete
}: FileListProps) {
  const progressFiles = Object.values(uploadProgress);
  if (files.length === 0 && progressFiles.length === 0) {
    return <div className="text-center py-8 text-gray-500" data-id="element-2127">
                <File className="w-12 h-12 mx-auto mb-2 text-gray-300" data-id="element-2128" />
                <p data-id="element-2129">No files uploaded yet</p>
            </div>;
  }
  return <div className="space-y-2" data-id="element-2130">
            {/* Uploading files */}
            {progressFiles.map(progress => <div key={progress.fileName} className="flex items-center gap-3 p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-2131">
                    <Loader className="w-5 h-5 text-blue-500 animate-spin" data-id="element-2132" />
                    <div className="flex-1 min-w-0" data-id="element-2133">
                        <p className="text-sm font-medium text-gray-900 truncate" data-id="element-2134">
                            {progress.fileName}
                        </p>
                        <div className="mt-1" data-id="element-2135">
                            <div className="w-full bg-blue-200 rounded-full h-2" data-id="element-2136">
                                <div className="bg-blue-600 h-2 rounded-full transition-all duration-300" style={{
              width: `${progress.progress}%`
            }} data-id="element-2137" />
                            </div>
                            <p className="text-xs text-blue-600 mt-1" data-id="element-2138">
                                {Math.round(progress.progress)}% uploaded
                            </p>
                        </div>
                    </div>
                </div>)}

            {/* Uploaded files */}
            {files.map(file => <div key={file.id} className="flex items-center gap-3 p-3 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors" data-id="element-2139">
                    {getFileIcon(file.fileType)}
                    <div className="flex-1 min-w-0" data-id="element-2140">
                        <p className="text-sm font-medium text-gray-900 truncate" data-id="element-2141">
                            {file.fileName}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2142">
                            {formatFileSize(file.fileSize)} • {file.category}
                        </p>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-2143">
                        <a href={file.storageUrl} target="_blank" rel="noopener noreferrer" className="p-2 text-blue-600 hover:bg-blue-50 rounded-md transition-colors" title="Download" data-id="element-2144">
                            <Download className="w-4 h-4" data-id="element-2145" />
                        </a>
                        <button onClick={() => onDelete(file)} className="p-2 text-red-600 hover:bg-red-50 rounded-md transition-colors" title="Delete" data-id="element-2146">
                            <Trash2 className="w-4 h-4" data-id="element-2147" />
                        </button>
                    </div>
                </div>)}
        </div>;
}